angular.module("tromanWeb").controller('OrganizationController', ['stateService', 'tromanServer', 'dialogService', 'organizationState', function (stateService, tromanServer, dialogService, organizationState) {

    var self = this;

    self.organizationTypes = organizationState.organizationTypes;
    self.wageGroups = organizationState.wageGroups;
    self.wageCalculations = organizationState.wageCalculations;
    self.users = organizationState.users;
    self.organization = organizationState.organization;
    self.persons = organizationState.persons;
    self.enableArchive = !!(self.organization.Id && self.organization.Active);

    self.canArchive = function () {
        if (!self.enableArchive) return false;
        if (organizationState.form != null) {
            if (organizationState.form.$dirty)
                return false;
        }

        return true;
    };

    self.canActivate = function () {
        if (self.enableArchive) return false;
        if (organizationState.form != null) {
            if (organizationState.form.$dirty)
                return false;
        }

        return true;
    };

    self.archive = function archive() {
        if (!self.canArchive()) return;

        dialogService.confirm(["Arkivera " + self.organization.Name + ".", "Är du säker?"]).then(function () {
            tromanServer.Organizations.archive(self.organization.Id)
                .then(function () { stateService.forceReload(); })
                .catch(dialogService.error);
        });
    };

    self.activate = function activate() {
        if (!self.canActivate()) return;

        dialogService.confirm(["Aktivera " + self.organization.Name + ".", "Är du säker?"]).then(function () {
            tromanServer.Organizations.activate(self.organization.Id)
                .then(function () { stateService.forceReload(); })
                .catch(dialogService.error);
        });
    };

    self.hardRemove = function hardRemove() {
        if (self.organization == null || self.organization.Id == null) return;

        dialogService.confirm(["Radera " + self.organization.Name + " permanent.", "Detta kan inte ångras", "Är du säker?"]).then(function () {
            tromanServer.Organizations.hardRemove(self.organization.Id)
                .then(function () { stateService.forceGo('organizations'); })
                .catch(dialogService.error);
        });
    };
}]);
